import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { Intervention } from '../shared/models/intervention.model';
import { Profile } from '../shared/models/profile.model';

@Injectable({
  providedIn: 'root',
})
export class ParcoursIbodeService {
  public openMaterialDialogSubject: Subject<boolean> = new Subject<boolean>();

  public openInterventionDialogSubject: Subject<boolean> = new Subject<boolean>();

  public loadProfileSubject: Subject<boolean> = new Subject<boolean>();

  public defaultProfileSubject: BehaviorSubject<Profile | null> = new BehaviorSubject<Profile | null>(null);

  public loadInterventionSubject: Subject<Intervention> = new Subject<Intervention>();

  public onSearchMaterialSubject: Subject<string> = new Subject<string>();

  public scrollSubject = new Subject<boolean>();

  public selectSpecialtySubject = new Subject<any>();

  sendSpecialty(specialty: any) {
    this.selectSpecialtySubject.next(specialty);
  }

  onSpecialty() {
    return this.selectSpecialtySubject.asObservable();
  }

  sendScroll() {
    this.scrollSubject.next(true);
  }

  scrollToElement(element: Element): void {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  onScrolling() {
    return this.scrollSubject.asObservable();
  }

  clear(): void {
    this.openMaterialDialogSubject.complete();
    this.openMaterialDialogSubject = new Subject<boolean>();

    this.openInterventionDialogSubject.complete();
    this.openInterventionDialogSubject = new Subject<boolean>();

    this.loadProfileSubject.complete();
    this.loadProfileSubject = new Subject<boolean>();

    this.defaultProfileSubject.complete();
    this.defaultProfileSubject = new BehaviorSubject<Profile | null>(null);

    this.loadInterventionSubject.complete();
    this.loadInterventionSubject = new Subject<Intervention>();

    this.onSearchMaterialSubject.complete();
    this.onSearchMaterialSubject = new Subject<string>();

    this.scrollSubject.complete();
    this.scrollSubject = new Subject<boolean>();

    this.selectSpecialtySubject.complete();
    this.selectSpecialtySubject = new Subject<any>();
  }
}
